import { createFileRoute, redirect } from '@tanstack/react-router';

import { TeamMemberNotificationView } from '@apps/web/components/settings/team_member_notification_editor';
import { isNotificationChannelSlug } from '@apps/web/lib/notification_channel_pages';

export const Route = createFileRoute(
    '/_app/settings/team-members_/$memberUserId/notifications/$channel',
)({
    beforeLoad: ({ params }) => {
        if (!isNotificationChannelSlug(params.channel)) {
            throw redirect({
                to: '/settings/team-members/$memberUserId/notifications',
                params: { memberUserId: params.memberUserId },
            });
        }
    },
    component: TeamMemberNotificationChannel,
});

function TeamMemberNotificationChannel() {
    const { memberUserId, channel } = Route.useParams();
    if (!isNotificationChannelSlug(channel)) {
        return null;
    }
    return (
        <TeamMemberNotificationView
            memberUserId={memberUserId}
            channel={channel}
        />
    );
}
